import React, { useEffect, useState } from 'react';
import { proService } from '../../services';
import { ClubPanel, PanelHead, PillButton, MUTED, INSET, RED } from '../club/clubUi';

/**
 * CLOSED — the Pro pages this account closed that are still inside the 30-day window, each
 * with BRING IT BACK. Renders nothing when there are none. Lives on the dashboard's SETTINGS
 * tab and in the NO PRO PAGE YET state (a closed only page lands there).
 */
export default function ClosedProPages({ onRestored, phone = false }) {
  const [rows, setRows] = useState([]);
  const [busy, setBusy] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    let live = true;
    let p = null;
    try { p = typeof proService.listDeleted === 'function' ? proService.listDeleted() : null; } catch { p = null; }
    if (p && typeof p.then === 'function') p.then((r) => { if (live && r?.success) setRows(r.data || []); }).catch(() => {});
    return () => { live = false; };
  }, []);

  if (rows.length === 0) return null;

  const restore = async (c) => {
    setBusy(c.id); setError(null);
    const r = await proService.restorePage(c.id);
    setBusy(null);
    if (!r.success) { setError(r.error || 'Could not bring it back. Try again.'); return; }
    setRows((rs) => rs.filter((x) => x.id !== c.id));
    onRestored?.(r.data);
  };

  return (
    <ClubPanel phone={phone} style={{ gap: 8 }} data-testid="closed-pro-pages">
      <div style={{ paddingBottom: 6 }}><PanelHead title="CLOSED" right="STILL YOURS TO BRING BACK FOR 30 DAYS" /></div>
      {error && <span style={{ fontSize: 11, color: RED }} role="alert">{error}</span>}
      {rows.map((c) => {
        const daysLeft = Math.max(0, Math.ceil((new Date(c.restoreUntil).getTime() - Date.now()) / 86400000));
        return (
          <div key={c.id} className="flex flex-wrap items-center" style={{ gap: 10, padding: '10px 10px 10px 18px', borderRadius: 22, background: INSET }} data-testid="closed-pro-row">
            <span className="flex min-w-0 flex-col" style={{ flex: '1 1 200px', gap: 3 }}>
              <span className="truncate" style={{ fontSize: 12, fontWeight: 800, letterSpacing: '.1em', textTransform: 'uppercase' }}>{c.name}</span>
              <span style={{ fontSize: 10, letterSpacing: '.08em', color: MUTED, textTransform: 'uppercase' }}>/pro/{c.slug} · {daysLeft} DAY{daysLeft === 1 ? '' : 'S'} LEFT</span>
            </span>
            <PillButton size={38} onClick={() => restore(c)} disabled={busy === c.id || !c.canRestore} style={{ opacity: busy === c.id || !c.canRestore ? 0.5 : 1 }} data-testid="restore-page">
              {busy === c.id ? '…' : 'BRING IT BACK'}
            </PillButton>
          </div>
        );
      })}
    </ClubPanel>
  );
}
